import { Button, Container, Grid } from "@mui/material";
import { Link } from "react-router-dom";

function RegistrationConfirmation() {
  return (
    <Container maxWidth="xl">
      <title>Registration confirmation</title>
      <h1>Registration application accepted</h1>
      <h2>Wait for confirmation of the application from the administrator</h2>
      <Grid item xs={12}>
        <Button variant="contained" component={Link} to="/login">
          Ok
        </Button>
      </Grid>
    </Container>
  );
}

export default RegistrationConfirmation;
